import { useTranslation as useI18nTranslation } from 'react-i18next';

/**
 * Provides translations to all components that utilize translateText. If a language update occurs anywhere in the react app
 * either programatically or via the language picker, then any component that uses this hook will automatically get the
 * updated translations.
 */
export default function useTranslation() {
  const { t, i18n } = useI18nTranslation();
  const lang = i18n.language;

  const getPartnerCustomizationValue = (customization: object, key: string) => {
    if (!customization) {
      return null;
    }

    const pathParts = key.split('/');
    let root:any = customization;
    while (pathParts.length > 0) {
      const part:any = pathParts.shift() || '';
      if (!(part in root)) {
        return null;
      }
      root = root[part];
      if (pathParts.length === 0 && root) {
        return root;
      }
    }
    return null;
  };

  const translateText = (defaultVal: string = '', key:string = '') => {
    const { partnerCustomizedAttributesJSON } = window.appAirDrop.config;

    try {
      const customTranslations = getPartnerCustomizationValue(partnerCustomizedAttributesJSON, key);
      const translatedText = customTranslations?.[lang] || t(defaultVal);

      return translatedText;
    } catch (error) {
      console.log(`Translation error: ${error}`);
      return t(defaultVal);
    }
  };

  return { translateText, lang, i18n };
}
